import React from 'react';

import { DataTable, EmptyState, Layout, Page, Text, Link, Badge, Card, Icon, InlineStack, InlineGrid } from '@shopify/polaris';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import emptyIMG from '../../media/images/empty.png';
import Pagination from '../../components/pagination';
import helpers from '../../helpers';
import dateandtime from 'date-and-time';
import SkeletonLoading from 'components/skeletonPageLoading';
import SimpleFilter from 'components/simpleFilter';
import { ___ } from 'languages/index';
import { TypedJourney, useGetJourneys } from 'queries/journey.query';
import { Helmet } from 'react-helmet-async';
import SeatingModal from './journey.modal';
import { PlusIcon, StarFilledIcon } from '@shopify/polaris-icons';

export default function JourneyList() {
  const [entities, setEntities] = useState<TypedJourney[]>([]);
  const [totalItems, setTotalItems] = useState(0);

  const history = useNavigate();

  /**
   * If user apply filter, it will add to URL, then parse URL back to initial state
   */
  let { search } = useLocation();
  let StringQuery: any = helpers.ExtractUrl(search);

  const initialQuery = {
    query: '',
    page: 1,
    limit: 20,
    journey_parent: 0,
    sort: 'createdAt:desc',
  };
  const [mainQuery, setMainQuery] = useState({
    ...initialQuery,
    ...StringQuery,
  });

  const { data, refetch: getEntities, isPending: loading } = useGetJourneys(mainQuery);

  useEffect(() => {
    if (data) {
      setEntities(data.body);
      setTotalItems(data.totalItems);
    }
  }, [data]);

  /**
   * Change page number
   */
  const onChangePagination = useCallback(
    (numPage: number, limit: number) => {
      setMainQuery({ ...mainQuery, page: numPage, limit: limit });
    },
    [mainQuery]
  );

  /**
   * Double request!
   */
  useEffect(() => {
    let buildURLSearch = helpers.buildEndUrl(mainQuery);
    if (search !== buildURLSearch) history('/journey' + buildURLSearch);
    getEntities();
  }, [mainQuery]);

  /**
   * I do not know ...
   * Bug: In React, do NOT remove this code
   */
  const filterCallback = useCallback((_value: any) => {
    if (_value === false) {
      return setMainQuery(initialQuery);
    } else {
      setMainQuery((oldValue) => {
        return { ...oldValue, ..._value };
      });
    }
  }, []);

  const [newModelactive, setNewModelactive] = useState(false);
  const toggleNewActive = useCallback(() => setNewModelactive((active) => !active), []);

  const currentVehicleID = useRef(null);

  const emptyData = (
    <EmptyState heading="Không có bản ghi!" image={emptyIMG}>
      <p>Oh, Không có gì ở đây. Hãy thử bỏ bộ lọc hoặc tạo mới.</p>
    </EmptyState>
  );

  const renderItem = (vehicle: TypedJourney) => {
    const {
      id,
      journey_name,
      journey_description,
      journey_distance,
      journey_from,
      journey_from_geo,
      journey_to,
      journey_to_geo,
      journey_default_price,
      journey_total_time,
      journey_status,
      createdAt,
      is_default,

      seating,
    } = vehicle;
    return [
      String(id),
      <Link
        key={id}
        url={`./view/${id}`}
        onClick={() => {
          // currentVehicleID.current = id;
          // toggleNewActive();
        }}
      >
        <InlineStack>
          <div>{is_default ? <Icon source={StarFilledIcon} /> : ''}</div>
          <div>
            <strong>{journey_name}</strong>
          </div>
        </InlineStack>
      </Link>,
      journey_from,
      journey_to,
      helpers.formatNumberWithCommas(journey_default_price),
      helpers.minuteToFullHourString(journey_total_time),
      Number(journey_distance || 0) + ' km',
      seating?.seating_name || '-',
      journey_status === 1 ? <Badge tone="success">Hoạt động</Badge> : <Badge tone="warning">Ngừng hoạt động</Badge>,
      createdAt ? dateandtime.format(new Date(Number(createdAt)), 'HH:mm:ss DD-MM-YYYY') : '-',
    ];
  };

  const PagesList =
    entities?.length > 0 ? (
      <>
        <DataTable
          hoverable
          fixedFirstColumns={2}
          columnContentTypes={['text', 'text', 'text', 'text', 'text', 'text', 'text', 'text']}
          headings={[
            'ID',
            'Tên hành trình',
            'Từ',
            'Đến',
            'Giá mặc định',
            'Tổng thời gian',
            'Khoảng cách hành trình',
            'Loại xe mặc định',
            'Tình trạng',
            'Tạo',
          ]}
          rows={entities?.map(renderItem)}
          hideScrollIndicator
          footerContent={___('Show page {display_page_number} of {total_record_number} results', {
            display_page_number: <Text as="strong">{mainQuery?.page || 1}</Text>,
            total_record_number: <Text as="strong">{totalItems}</Text>,
          })}
        />
      </>
    ) : (
      emptyData
    );

  const Actual_page = (
    <>
      <Helmet>
        <title>Danh sách hành trình</title>
      </Helmet>
      <Page
        title="Hành trình"
        primaryAction={{
          content: 'Thêm hành trình',
          disabled: false,
          icon: PlusIcon,
          onAction: toggleNewActive,
        }}
      >
        <Layout>
          <Layout.Section>
            <Card padding="0">
              <SimpleFilter loading={loading} onCallback={filterCallback} options={[]} sortField={[]} />
              {PagesList}
            </Card>
            <br />
            {totalItems > mainQuery.limit ? (
              <Pagination TotalRecord={totalItems} activeCurrentPage={mainQuery.page} pageSize={mainQuery.limit} onChange={onChangePagination} />
            ) : null}
          </Layout.Section>
        </Layout>
      </Page>
      {
        <SeatingModal
          show={newModelactive}
          currentVehicleID={currentVehicleID.current}
          onClose={() => {
            currentVehicleID.current = null;
            setNewModelactive(false);
          }}
        />
      }
    </>
  );

  return <>{entities === null ? <SkeletonLoading /> : Actual_page}</>;
}

